"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var Iubenda = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Iubenda, _PureComponent);

  function Iubenda() {
    (0, _classCallCheck2["default"])(this, Iubenda);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Iubenda).apply(this, arguments));
  }

  (0, _createClass2["default"])(Iubenda, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.innerHTML = '!function(e,t){var n=function(){var e=t.createElement("script"),n=t.getElementsByTagName("script")[0];e.src="https://cdn.iubenda.com/iubenda.js",n.parentNode.insertBefore(e,n)};e.addEventListener?e.addEventListener("load",n,!1):e.attachEvent?e.attachEvent("onload",n):e.onload=n}(window,document);';
      script.async = true;
      if (document.body != null) document.body.appendChild(script);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          styling = _this$props.styling,
          children = _this$props.children,
          type = _this$props.type;
      var styleTypes = {
        nostyle: "iubenda-nostyle no-brand iubenda-embed",
        black: "iubenda-black no-brand iubenda-embed",
        white: "iubenda-white no-brand iubenda-embed"
      };

      var makeUrl = function makeUrl() {
        var prId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var prType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

        if (prType === "cookie") {
          return "https://www.iubenda.com/privacy-policy/".concat(prId, "/cookie-policy");
        }

        if (prType === "privacy") {
          return "https://www.iubenda.com/privacy-policy/".concat(prId);
        }

        return "https://www.iubenda.com/".concat(prType, "/").concat(prId);
      };

      return _react["default"].createElement("a", {
        href: makeUrl(id, type),
        className: styleTypes[styling || "nostyle"]
      }, children);
    }
  }]);
  return Iubenda;
}(_react.PureComponent);

exports["default"] = Iubenda;
(0, _defineProperty2["default"])(Iubenda, "defaultProps", {
  styling: "nostyle",
  children: "Privacy Policy",
  type: "privacy"
});